<template>
    <ChildFormModel
        :add-action="addAction"
        :update-action="updateAction"
        :delete-action="deleteAction"
        :view-action="viewAction"
        category="FILTER"
    />
</template>

<script>
import ChildFormModel from "@/views/Notification/ControlProgram/Components/ChildFormModel.vue";

export default {
    name: "ChildControlProgramForm",
    components: {ChildFormModel},
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        deleteAction: Boolean,
        viewAction: Boolean,
    }
}
</script>

<style scoped>

</style>